import * as Yup from "yup";
import i18n from "../i18n";

export const EmailSchema = Yup.object({
  subject: Yup.string().required(
    i18n.language === "en" ? "Subject is required" : "الموضوع مطلوب"
  ),
});
